import { CENTS_PER_UNIT, FLOATING_POINT_PRECISION_DIGITS } from '../constants/common'
import { isUruguay } from './country'

export const roundAmount = (amount) => Math.round(amount * CENTS_PER_UNIT) / CENTS_PER_UNIT

export const getDeliveryCostPrice = (subtotal, discount, country) => {
  const amount = subtotal - discount
  return isUruguay(country) ? roundAmount(amount) : parseInt(amount, 10)
}

export const floorAmount = (amount, decimals) => {
  const factor = 10 ** decimals
  const scaledAmount = Number((amount * factor).toFixed(FLOATING_POINT_PRECISION_DIGITS))

  return Math.floor(scaledAmount) / factor
}

export const applyChangesInPrices = (addedGiftCard, removedGiftCard, cartData, setCartData) => {
  const { subtotal, shippingCost: realShippingCost, discount, giftCard, isFreeShipping } = cartData
  const shippingCost = isFreeShipping ? 0 : realShippingCost
  if (addedGiftCard) {
    giftCard.total += Number(addedGiftCard.balance)
    giftCard.cards.push(addedGiftCard)
  }
  if (removedGiftCard) {
    giftCard.total -= Number(removedGiftCard.balance)
    const filteredCards = giftCard.cards.filter(card => card.last_characters !== removedGiftCard.last_characters)
    giftCard.cards = filteredCards
  }
  const parcialTotal = roundAmount(subtotal - discount + shippingCost) || 0
  const isTotalPriceHigher = parcialTotal > giftCard.total
  const newTotal = isTotalPriceHigher ? roundAmount(parcialTotal - giftCard.total) : 0
  const giftCardApplied = isTotalPriceHigher ? giftCard.total : parcialTotal

  setCartData(prevState => {
    return {
      ...prevState,
      giftCard: { total: giftCard.total, applied: giftCardApplied, cards: giftCard.cards },
      total: newTotal
    }
  })
}
